import { Expose } from 'class-transformer';

export class AgencyEseData {
    @Expose({ name: 'NomeAgenzia' })
    agencyName: string;

    @Expose({ name: 'IndirizzoAgenzia' })
    agencyAddress: string;
}
